import React from 'react';
import PropTypes from 'prop-types';

import { Col, Grid, Card, CardContent, Button } from '@common/components';

import { useTranslation } from 'react-i18next';

import centerStyles from './CenterCard.module.scss';

export default function CenterCard({ center }) {
  const { t } = useTranslation('dashboard\\CenterCard');
  const filters = useTranslation('dashboard\\MainFilters');

  const handleOpenCenter = (cnt) => {
    window.open(cnt.app_url);
  };

  return (
    center && (
      <Card>
        <CardContent>
          <Grid align="stretch" justify="space-between">
            <Col xss={12} xs={12} sm={8} md={9}>
              <Grid align="stretch" justify="space-between">
                <Col xss={12} xs={12} sm={12} md={6}>
                  <div className={centerStyles.sectionGreen}>
                    {t(center.name)}
                  </div>
                  <div className={centerStyles.containerCountry}>
                    <div className={centerStyles.section}>
                      <span>{t('labelCountry')}</span>
                      <strong>{filters.t(center.country_code)}</strong>
                    </div>
                    <div className={centerStyles.section}>
                      <span>{t('labelOrigin')}</span>
                      <strong>{t(center.origin)}</strong>
                    </div>
                  </div>
                </Col>
                <Col xss={12} xs={12} sm={12} md={12} lg={6}>
                  <div className={centerStyles.statsContainer}>
                    <div className={centerStyles.statsContent}>
                      <div className={centerStyles.section}>
                        <strong>{t('labelTeachers')}</strong>
                      </div>
                      <div className={centerStyles.section}>
                        <span>{t('labelRegistered')}</span>
                        <strong>{filters.t(center.registered_teachers)}</strong>
                        <span>{t('labelActive')}</span>
                        <strong>{filters.t(center.active_teachers)}</strong>
                      </div>
                      <div className={centerStyles.section}>
                        <span>{t('labelLastAccess')}</span>
                        <strong>
                          {t(center.last_access_teachers)
                            ? center.last_access_teachers
                            : t('lblEmpty')}
                        </strong>
                      </div>
                    </div>
                    <div className={centerStyles.statsContent}>
                      <div className={centerStyles.section}>
                        <strong>{t('labelStudents')}</strong>
                      </div>
                      <div className={centerStyles.section}>
                        <span>{t('labelRegistered')}</span>
                        <strong>{filters.t(center.registered_students)}</strong>
                        <span>{t('labelActive')}</span>
                        <strong>{filters.t(center.active_students)}</strong>
                      </div>
                      <div className={centerStyles.section}>
                        <span>{t('labelLastAccess')}</span>
                        <strong>
                          {center.last_access_students
                            ? center.last_access_students
                            : t('lblEmpty')}
                        </strong>
                      </div>
                    </div>
                  </div>
                </Col>
              </Grid>
            </Col>
            <Col
              xss={12}
              xs={12}
              sm={2}
              md={2}
              className={centerStyles.btnContainer}
            >
              {center.origin !== 'integral-offline' && (
                <Button
                  variant="outline"
                  color="accent"
                  onClick={() => handleOpenCenter(center)}
                >
                  {t('labelShow')}
                </Button>
              )}
            </Col>
          </Grid>
        </CardContent>
      </Card>
    )
  );
}

CenterCard.propTypes = {
  center: PropTypes.object,
};
